import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Shell from "./components/Shell";
import Subadmin from "./screens/SubAdmins/Subadmin.js";
import UserDetails from "./screens/User/UserDetail.js";
import AddService from "./screens/Services/AddService.js";
import CategoryScreen from "./screens/CategoryScreen/CategoryScreen.js";
import ManageServices from "./screens/Services/ManageService.js";
import ViewService from "./screens/Services/ViewService.js";
import ManageVendors from "./screens/Vendors/ManageVendors.js";
import Audits from "./screens/Audits/Audit.js";
import VendorDetails from "./screens/Vendors/VendorDetails.js";
import ManageAudit from "./screens/Audits/ManageAudit.js";
import Bookings from "./screens/Bookings/Booking.js";
import ManageBooking from "./screens/Bookings/ManageBooking.js";
import Login from "./screens/Login/Login.js";
import Users from "./screens/User/Users.js";
import StaffList from "./screens/ManageStaff/ListStaff.js";
import StaffDetails from "./screens/ManageStaff/StaffDetails.js";
import { endSession, getAccount } from "./session";
import { firstAllowedPath } from "./components/navigation";

function App() {
  const [loggedInUser, setLoggedInUser] = useState(() => getAccount());

  const handleLogout = () => {
    endSession();
    setLoggedInUser(null);
  };

  if (!loggedInUser) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login setLoggedInUser={setLoggedInUser} />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    );
  }

  const can = (permission) => (loggedInUser.permissions || []).includes(permission);
  const home = firstAllowedPath(loggedInUser.permissions || []);

  return (
    <Router>
      <Shell user={loggedInUser} logout={handleLogout}>
        <Routes>
          <Route path="/login" element={<Navigate to={home} replace />} />
          {can("Sub Admins") && <Route path="/" element={<Subadmin />} />}
          {can("Service Category") && <Route path="/service-category" element={<CategoryScreen />} />}
          {can("Manage Services") && (
            <>
              <Route path="/manage-services" element={<ManageServices />} />
              <Route path="/manage-services/add-service" element={<AddService />} />
              <Route path="/manage-services/view-service/:id" element={<ViewService />} />
            </>
          )}
          {can("Manage Vendors") && (
            <>
              <Route path="/manage-vendors" element={<ManageVendors />} />
              <Route path="/manage-vendors/vendor/:id" element={<VendorDetails />} />
            </>
          )}
          {can("Users") && (
            <>
              <Route path="/manage-users" element={<Users />} />
              <Route path="/manage-users/user/:userId" element={<UserDetails />} />
            </>
          )}
          {can("Audits") && (
            <>
              <Route path="/audits" element={<Audits />} />
              <Route path="/audits/manage-audit/:audit_id" element={<ManageAudit />} />
            </>
          )}
          {can("Bookings") && (
            <>
              <Route path="/bookings" element={<Bookings />} />
              <Route path="/bookings/manage-booking/:booking_id" element={<ManageBooking />} />
            </>
          )}
          {can("Manage Staff") && (
            <>
              <Route path="/manage-staff" element={<StaffList />} />
              <Route path="/staff/:staffId" element={<StaffDetails />} />
            </>
          )}
          <Route path="*" element={<Navigate to={home} replace />} />
        </Routes>
      </Shell>
    </Router>
  );
}

export default App;
